import {
  ApplicantStatus,
  CheckoutSubmissionType,
  DecisionAction,
  PreferredSubmissionType,
  VerificationNames,
  VerificationStatus
} from "shared/types";

type MinimalApplicantForManualCheck = {
  is_manual: boolean;
  application_status: ApplicantStatus;
  finished_verifications: {
    total_steps: number;
    finished_steps: number;
  };
  preferred_checkout_type?: CheckoutSubmissionType;
  preferred_submission_disclosure_type?: PreferredSubmissionType;
  verifications: {
    name: VerificationNames;
    status: VerificationStatus;
  }[];
};

const MANUAL_APPLICATION_CLOSED_STATUSES = [
  ApplicantStatus.Canceled,
  ApplicantStatus.Submitted,
  ApplicantStatus.OnHold
];

export const isManualApplicationClosed = (status: ApplicantStatus) =>
  MANUAL_APPLICATION_CLOSED_STATUSES.includes(status);

export const hasActionInManualApplication = <
  T extends MinimalApplicantForManualCheck
>(
  applicant: T
): boolean => {
  if (!applicant.is_manual) return false;
  if (isManualApplicationClosed(applicant.application_status)) return false;

  // This means that we're waiting to checkout in email.
  if (
    applicant.preferred_checkout_type &&
    applicant.preferred_checkout_type === "send_by_email" &&
    applicant.application_status === ApplicantStatus.Finished
  )
    return false;

  // This means that we're waiting for applicant to sign the disclosure in email if it's the last application
  if (
    applicant.preferred_submission_disclosure_type &&
    applicant.preferred_submission_disclosure_type === "send_by_email" &&
    applicant.finished_verifications.total_steps -
      applicant.finished_verifications.finished_steps ===
      1 &&
    applicant.verifications.find(
      (v) => v.name === VerificationNames.SubmissionDisclosure
    )?.status !== VerificationStatus.Finished
  )
    return false;

  return true;
};

export const getDecisionRecommendationCardText = ({
  autoApproved,
  recommendation
}: {
  autoApproved?: boolean;
  recommendation?: DecisionAction;
}) => {
  if (autoApproved) return <>Automatically approved</>;

  let recommendationText = "conditional approval";
  if (recommendation === DecisionAction.Approve)
    recommendationText = "approval";
  if (recommendation === DecisionAction.Decline)
    recommendationText = "declining";

  return <>Recommended {recommendationText}</>;
};
